export default __webpack_public_path__ + "static/media/Q01_薄霧繚繞中海拔森林，青苔泥土氣息.6738eb89.mp4";